import React from 'react';
import { Grid, Grid2, useMediaQuery } from '@mui/material';
import LayoutMeja from '../componen/kasir/LayoutMeja';
const LayoutMejaKasir = ({userUuid}) => {
 const isMobile = useMediaQuery('(max-width:768px)'); 
  return (
   <>
   
      <Grid container>
        {!isMobile && (
          <>
            {/* <Grid item xs={3}>
              <Sidebar />
            </Grid> */}
            <Grid item xs={12}>
              <LayoutMeja userUuid={userUuid} />
            </Grid>
            {/* <Grid item xs={3}>
              <OrderList />
            </Grid> */}
          </>
        )}
        {isMobile && (
          <>
            <Grid item xs={12}>
              <LayoutMeja userUuid={userUuid} />
            </Grid>
            {/* <Grid item xs={12}>
              <Sidebar />
            </Grid>
            <Grid item xs={12}>
              <OrderList />
            </Grid> */}
          </>
        )}
      </Grid>
      </>
  );
};

export default LayoutMejaKasir